import { Box, Container, VStack, Text } from '@bpba/ui-components';
import { Banner } from '../components/Banner';
import { Title } from '../components/Title';
import AdhesionComerciosComponent from '../components/AdhesionComerciosComponent';
import { ADHESION_COMERCIOS } from '../Constantes';




export const AdhesionComercios: React.FC = () => {


    return (
        <Container>
            <VStack>
                <VStack>
                    <Banner borderRadius={['0px', '8px']} url={ADHESION_COMERCIOS} />
                    <Box flexDirection={['column', 'row']}>
                        <Box>
                            <VStack width={'100%'} p={['24px 16px', null, null, '32px 50px']}>
                                <Title title={'Adherí tu comercio'} ></Title>
                            </VStack>
                        </Box>
                        <Box
                            width={["100%", "90%", "85%", "65%"]}
                            p={["50px 16px", "50px 16px", "50px 20px", "75px 40px"]}
                            mr={["0px", "15px", "20px", "50px"]}
                            bg="secondary.2"
                            minHeight={["400px", "500px", "500px"]}>
                            <AdhesionComerciosComponent/>
                        </Box>
                    </Box>
                    <Box py={4} px={['16px', null, null, '50px']} flexDirection={"column"}>

                        <Text fontSize={"12px"} lineHeight={"18px"} textAlign={"justify"}>

                            El clic en SÍ ACEPTO implica conformidad para que los datos de esta presolicitud sean enviados al Banco de la Provincia de Buenos Aires y sin que ello importe su aceptación. Asimismo, tomo conocimiento de los <a style={{ color: "rgb(60, 60, 59)" }} href='https://www.bancoprovincia.com.ar/CDN/Get/TYC_BIP'>términos y condiciones para la utilización de Banca Internet Provincia</a> y de la información necesaria para su correcta utilización, los riesgos derivados de su empleo y quien asume los mismos. El clic en IMPRIMIR me permite obtener una copia que también se encuentra a la disposición en www.bancoprovincia.com.ar
                            <br/>
                            <br/>
                            Cartera de Consumo - Términos y condiciones <br /> <b>Aspectos relativos a la operatoria</b> El clic en <b>SÍ ACEPTO</b> importará mi expresa aceptación a todos y cada uno de los Términos y Condiciones indicados precedentemente y la constancia de haber tomado conocimiento y aceptado los
                            <a style={{ color: "#3c3c3b", fontWeight: "bold" }} href="https://www.bancoprovincia.com.ar/CDN/Get/Terminos_y_condiciones_Banco_Provincia" target='_blanc'> Términos y Condiciones para la utilización de Banca Internet Provincia y/o el sitio web del Banco de la Provincia de Buenos Aires</a>; así como también de haber obtenido toda la información necesaria para utilizar correctamente este medio, los riesgos derivados de su empleo y quien asume los mismos. El click en <b>IMPRIMIR</b> me permite obtener una copia del presente, cuyo texto también se encuentra a mi disposición en <a style={{ color: "#3c3c3b", fontWeight: "bold" }} href="https://www.bancoprovincia.com.ar/" target='_blanc'>www.bancoprovincia.com.ar</a>

                        </Text>
                    </Box>
                </VStack>

            </VStack>
        </Container>

    )

}



